<template>
	<div>
		<Dropdown placement="end">
			<template #trigger="{ open }">
				<PButton type="text" color="neutral" icon="more" only-icon @click="handleOpen(open)" />
			</template>
			<template #default="{ close }">
				<MenuList v-if="isOpen">
					<MenuItem
						:disabled="disabledResend"
						icon="mail"
						class="text-neutral-800"
						:name="$t('web.trip.invite.actions.resend_invitation')"
						@click="(resend(), close())"
					/>
					<MenuItem
						icon="trash"
						class="text-error-400"
						:name="$t('web.trip.invite.actions.remove_from_Trip')"
						@click="($emit('remove'), close())"
					/>
				</MenuList>
			</template>
		</Dropdown>
	</div>
</template>

<script setup lang="ts">
	import { onBeforeUnmount, ref } from 'vue'

	const emit = defineEmits(['resend', 'remove'])

	const isOpen = ref<boolean>(false)
	const disabledResend = ref<boolean>(false)

	let resendTimer: number | undefined

	const handleOpen = (open: () => void) => {
		isOpen.value = !isOpen.value
		open()
	}

	const resend = () => {
		if (resendTimer) window.clearTimeout(resendTimer)
		disabledResend.value = true
		handleDisabled()
		emit('resend')
	}

	const handleDisabled = () => {
		resendTimer = window.setTimeout(() => {
			disabledResend.value = false
			resendTimer = undefined
		}, 60000)
	}

	onBeforeUnmount(() => {
		if (resendTimer) window.clearTimeout(resendTimer)
	})
</script>
